import { render, staticRenderFns } from "./ExContentDetail.vue?vue&type=template&id=3aaee6b9&"
import script from "./ExContentDetail.vue?vue&type=script&lang=js&"
export * from "./ExContentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports